export default __webpack_public_path__ + "static/media/dayw.5d7fad43.gif";